import { createContainer } from '@dbk-legacy/muster/react';

import Transaction from './transaction';

export function factory({
  component = Transaction,
} = {}) {
  return createContainer({
    $queries: {
      changePage: { $call: 'ui.history.push' },
      transact:{
        isEmpty: true,
        setIsEmpty: { $set: 'isEmpty' },
        getAdvices : { $call: 'getTransactionAdvices'},
      },
    },
    $fragments: {
      uiStatic: {
        options: true,
        labels: true,
      },
      row: {
        type: true,
        quantity: true,
        netAmount: true,
        tradeDate: true,
        valueDate: true,
        purchasePrice: true,
        netAmount: true,
        grossAmount: true,
        tradeNumber: true,
        securityLongName : true,
        tradeType: true,
        posDesc: true
      },
    },
  }, ({ uiStatic, row, changePage, transact, ...rest }) => ({
    row,
    columnWidths: uiStatic.options.map(({ width }) => width),
    options: uiStatic.options,
    labels: uiStatic.labels,
    changePage, transact,
    ...rest
  }))(component);
}

export default factory();
